import React from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, price, productImageUrl } from '../data/product';
const items = ['6 core functional coaching volumes', '5 strategic exclusive bonus resources', '60+ ready-to-coach sessions', 'Lifetime digital access (high-res PDF)', 'Tablet, desktop and print optimized'];
const assurances = [{
  icon: LockKeyholeIcon,
  label: 'Secure SSL payment'
}, {
  icon: ZapIcon,
  label: 'Instant access'
}, {
  icon: CreditCardIcon,
  label: 'Card · Google Pay · Apple Pay'
}];
export function PricingSection() {
  return <section id="offer" className="scroll-mt-0 bg-stone-100 px-5 py-20" data-id="element-119" data-mp="1x9hw1x3k66l5">
      <div className="mx-auto max-w-xl text-center" data-id="element-120" data-mp="227b4kwsc3col">
        <p className="inline-block bg-ink-900 px-4 py-2 text-[11px] font-semibold uppercase tracking-[.2em] text-stone-100" data-id="element-121" data-mp="2v8mnqzcyqd1">
          Limited-time launch offer
        </p>
        <h2 className="mt-5 font-display text-[2.1rem] font-semibold uppercase leading-[1.02] tracking-[.01em] text-ink-900 sm:text-5xl" data-id="element-122" data-mp="7vmv3a4vg2bl">
          All-inclusive access,
          <span className="block font-medium normal-case italic tracking-normal text-clay-500" data-id="element-123" data-mp="1hodhefuew1vh">
            one single payment.
          </span>
        </h2>
        <p className="mt-4 text-sm text-ink-600" data-id="element-124" data-mp="17sacx3c37r5d">
          No subscription. No recurring fees. No surprises.
        </p>
        <article className="mt-10 overflow-hidden border border-line bg-white text-center shadow-[0_20px_50px_rgba(43,41,37,.08)]" data-id="element-125" data-mp="25ehes5h0b5e1">
          <header className="border-b border-line bg-ink-900 px-6 py-8" data-id="element-126" data-mp="20ecyogk0gcoc">
            <h3 className="font-display text-2xl font-semibold uppercase tracking-[.04em] text-white sm:text-3xl" data-id="element-127" data-mp="1vg1no2hzbw4j">
              Functional Ready™ — The Complete System
            </h3>
            <p className="mt-2 text-[11px] font-semibold uppercase tracking-[.2em] text-clay-300" data-id="element-128" data-mp="k38z10khjnsp">
              6 volumes + 5 strategic bonuses
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-129" data-mp="hh8chl82ohb8">
            <img src={productImageUrl} alt="Everything included in the Functional Ready complete system" width={1280} height={853} loading="lazy" className="mx-auto mb-4 w-full max-w-md object-contain" data-id="element-130" data-mp="hiazvj66s1me" />
            <div id="offer-details" className="scroll-mt-6 border-y border-line py-7" data-id="element-131" data-mp="ch3svmbvb6gs">
              <p className="mb-5 text-[11px] font-semibold uppercase tracking-[.2em] text-ink-900" data-id="element-132" data-mp="3uuthek3uawrq">
                What is included
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-133" data-mp="3kzjjo8kh5bjr">
                {items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-ink-800" data-id="element-134" data-mp="3pycshnotgedl">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage-600" data-id="element-135" data-mp="3fz5inahaj1v8" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-8" data-id="element-136" data-mp="2xcxy8cv7wdm0">
              <p className="text-sm text-ink-600" data-id="element-137" data-mp="2scs4mr5e0h1a">
                Total value: <s data-id="element-138" data-mp="2secvo6shthue">{price.total} USD</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center gap-2 text-ink-900" data-id="element-139" data-mp="36ckqo95yy92x">
                <span className="font-display text-3xl font-semibold" data-id="element-140" data-mp="31bx1zu57q4bv">
                  only
                </span>
                <strong className="font-display text-7xl font-semibold leading-none tracking-tight sm:text-8xl" data-id="element-141" data-mp="3g8e9gaaa6yt5">
                  {price.current}
                </strong>
                <span className="font-display text-3xl font-semibold tracking-[.04em]" data-id="element-142" data-mp="3p17u6n8hyqee">
                  USD
                </span>
              </div>
              <div className="mt-4 flex flex-wrap justify-center gap-3" data-id="element-143" data-mp="3l31svuqfh30v">
                <span className="bg-sage-600 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-white" data-id="element-144" data-mp="2vkrxyxyjaru">
                  You save {price.savings}
                </span>
                <span className="py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-ink-600" data-id="element-145" data-mp="hxayebakb9l2">
                  One-time payment
                </span>
                <span className="py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-ink-600" data-id="element-146" data-mp="qpw8l304o7ya">
                  Lifetime access
                </span>
              </div>
            </div>
            <a href={checkoutUrl} className="cta-button mt-8 block w-full px-6 py-5 text-base font-bold uppercase tracking-[.06em] sm:text-lg" data-id="element-147" data-mp="3v54g0lwp9k0a">
              Yes! I want Functional Ready™
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs text-ink-600" data-id="element-148" data-mp="7yljmrdyq591">
              <ShieldCheckIcon className="h-4 w-4 shrink-0 text-sage-600" data-id="element-149" data-mp="d0avuacx8oyp" />
              100% risk-free — covered by our 7-day money back guarantee
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 border-t border-line pt-6 text-xs font-medium text-ink-600" data-id="element-150" data-mp="1oddb923ab8ha">
              {assurances.map(({
              icon: Icon,
              label
            }) => <span key={label} className="flex items-center gap-1.5" data-id="element-151" data-mp="33wui35l8bdke">
                  <Icon className="h-4 w-4" data-id="element-152" data-mp="2z64cbr8w58p6" />
                  {label}
                </span>)}
            </div>
          </div>
        </article>
        <p className="mt-5 text-xs text-ink-600" data-id="element-153" data-mp="2u715q2d9iuf3">
          Final price {price.current} USD, one-time payment and immediate access
          to the digital material.
        </p>
      </div>
    </section>;
}